import { useContext, useEffect } from 'react'

import { Box } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { TraceabilityTree } from '../../components/TraceabilityTree'
import { useAuditItemTree } from '../../components/TraceabilityTree/hooks/useAuditItemTree'

import {
  AuditItemDetailsContext,
  AuditItemDetailsProvider,
} from './audit-item-details.context'
import { ItemHeader } from './components/ItemHeader/item-header.comp'

const AuditItemDetailsComp = () => {
  const { traceability, actions } = useContext(AuditItemDetailsContext)

  useEffect(() => {
    actions.fetchItemTraceability()
  }, [])

  const { initialNodes, initialEdges, nodeTypes } = useAuditItemTree({
    traceability,
  })

  const theme = useTheme()

  return (
    <Box
      width="100%"
      height="calc(100vh - 72px)"
      direction="column"
      padding={3}
      gap={3}
    >
      <BackButton url="/audit" />

      <ItemHeader />

      <Box
        width="100%"
        justifyContent="center"
        alignItems="center"
        borderRadius="12px"
        border={{ width: 1, color: 'grey_5' }}
        boxShadow={theme.box_shadow.card}
        flex={1}
      >
        <TraceabilityTree
          initialNodes={initialNodes}
          initialEdges={initialEdges}
          nodeTypes={nodeTypes}
          showDirectionSwitch={false}
          showMinimap={false}
          initialDirection="LR"
        />
      </Box>
    </Box>
  )
}

export const AuditItemDetails = () => {
  return (
    <AuditItemDetailsProvider>
      <AuditItemDetailsComp />
    </AuditItemDetailsProvider>
  )
}
